<template>
  <div style="height: 100%">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    
    <div>
        <vx-card>
            <div class="vx-row mb-4">
                <div class="vx-col md:w-1/2 w-full">                    
                    <vs-button class="ml-auto mt-2" size="small" @click="gravar" color="success" v-if="temPermissaoAlterar">Gravar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="excluir" v-show="isDeletable && temPermissaoAlterar" color="danger">Excluir</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>             
                </div>
            </div>                       
            <div class="vx-row">        
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Categoria</label>
                    <v-select          
                        label="nome"                                                 
                        :options="listaCategorias"                   
                        v-model="data_local.categoria"                             
                    class="v-select w-full"></v-select> 
                </div>      

                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Nome</label>
                    <vs-input class="w-full" v-model="data_local.nome" :maxlength="255"/>   
                </div>                 
            </div>
            <div class="vx-row">        
                <div class="vx-col w-full">
                    <label class="vs-input--label">Descrição</label>
                    <vs-input class="w-full" v-model="data_local.descricao" :maxlength="255"/>   
                </div>                 
            </div>  

            <div class="vx-row">                
                <div class="vx-col w-1/3">
                    <label class="vs-input--label">Unidade</label>                    
                    <v-select                                               
                        :options="CONSTANTES_UNIDADES_MEDIDA" 
                        v-model="data_local.unidadeMedida"    
                        :clearable="false"
                        :reduce="r => r.data"     
                        style="z-index: 10000 !important;"                                                                    
                        class="v-select w-full">
                    </v-select>  
                </div>                 
                <div class="vx-col w-1/3">
                    <label class="vs-input--label">Preço Compra</label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.precoCompra" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
                </div>                 
                <div class="vx-col w-1/3">
                    <label class="vs-input--label">Qtd em Estoque</label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.qtdAtual" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
                </div>                 
            </div>  
            
            
        </vx-card>  
    </div>
    
  </div>
</template>

<script>
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
const URL_SERVLET = "/Produto";
const NAME_ROUTE_SEARCH = "cadastro-produtos-pesquisar";
import { CONSTANTES_UNIDADES_MEDIDA } from '@/constantesComboBox.js'

export default { 
  components: {  
    VueAutonumeric
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { nome: null }
       }
    },
  },
  data() {
    return {        
        errorsValidacao: [],  
        listaCategorias: [],
        data_local: JSON.parse(JSON.stringify(this.registroOriginal))        
    }
  },  
  created(){
    this.CONSTANTES_UNIDADES_MEDIDA = CONSTANTES_UNIDADES_MEDIDA;    
  }, 
  mounted() {
    this.fetchCategorias();
    if (this.registroOriginal.hasOwnProperty('id')) {
        this.$vs.loading()
        this.findById();  
    } 
  },
  computed: {      
    isDesabilitarCampo(){
        return this.data_local != null && this.data_local.hasOwnProperty("id");
    }, 
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    }, 
    isGestor() {
      return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    },
    temPermissaoAlterar() {
        if ( this.isGestor ) {
            return true;
        } 

        if (this.data_local !== null && this.data_local.hasOwnProperty("id")) {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') {
                return true;
            }

            return false;
        } else {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') {
                return true;
            }

            return false;
        }        
    }
  },
  methods: {  
    fetchCategorias() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      
      axios.post("/CategoriaProduto/ListarCategoriaProduto", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaCategorias = response.data.Resultado.lista;              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    findById() {       
        const params = new URLSearchParams();       
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/RecuperarProduto", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close()            
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.Produto;                            
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                        
        params.append('listaIds', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/RemoverProduto", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();
            const params = new URLSearchParams();    
            
            if (this.data_local.hasOwnProperty('id')) {
                params.append('id', this.data_local.id);    
            }
            
            params.append('categoria.id', this.data_local.categoria.id);            
            params.append('nome', this.data_local.nome);            
            if (this.data_local.descricao) {
                params.append('descricao', this.data_local.descricao);
            }

            params.append('unidadeMedida', this.data_local.unidadeMedida);
            params.append('precoCompra', this.data_local.precoCompra);
            params.append('qtdAtual', this.data_local.qtdAtual);
            

            axios.post(URL_SERVLET + "/GravarProduto", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                    
                    this.$vs.loading.close()
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Produto.erroOperacao) {                 
                        this.$vs.loading.close()       
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Produto.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                        
                         this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Produto.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.Produto;  
                        this.findById();
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
        
        if (!this.data_local.categoria || !this.data_local.categoria.id) { this.errorsValidacao.push("Categoria obrigatória"); }

        if (!this.data_local.nome) { this.errorsValidacao.push("Nome obrigatório"); }
        if (!this.data_local.unidadeMedida) { this.errorsValidacao.push("Unidade de Medida obrigatório"); }
        if (!this.data_local.precoCompra) { this.errorsValidacao.push("Preço de Compra obrigatório"); }
              
        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },    
  }
}
</script>

<style scoped>  
  .vs__dropdown-menu {
    max-height: 80px;    
  }
</style>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>